import { faFileImport } from "@fortawesome/free-solid-svg-icons";
import HeaderActionConfig from "../HeaderActionConfig";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import useEvaApi, { EvaApiCall } from "../../../../../../hooks/useEvaApi";
import FileHelper from "../../../../../../helpers/FileHelper";

/**
 * @param {*} entity
 * @param {*} onImport
 * @param {*} loadingGroup
 * @returns {HeaderActionConfig}
 */
function useImportHeaderActionConfig(entity, onImport = null) {
  const callEvaApi = useEvaApi();
  const { translate } = useLanguageContext();
  const loadingGroup = `${entity}_import`;

  async function handleImport(dataTable) {
    const selectedFile = await FileHelper.select(".xlsx");
    if (!selectedFile) {
      return;
    }

    await callEvaApi(
      new EvaApiCall(`${entity}/import`)
        .setMethod("POST")
        .setLoadingGroup(loadingGroup)
        .setData({ file: selectedFile })
        .setOnSuccess(() => dataTable.fetch())
    );
  }

  return new HeaderActionConfig()
    .setIcon(faFileImport)
    .setCallback(onImport || handleImport)
    .setLoadingGroups(loadingGroup)
    .setTitle(
      translate("eva.main.entities.states.import", [
        {
          key: "entities",
          value: translate(`eva.main.entities.${entity}`),
        },
      ])
    );
}

export default useImportHeaderActionConfig;
